import { Link } from "react-router-dom";
import { Mail, Youtube, Twitter, Facebook, Instagram, MapPin } from "lucide-react";
import { CONTACT } from "../lib/api";

export const Footer = () => (
  <footer className="mt-24 border-t border-border bg-secondary/40" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 py-14 grid gap-10 md:grid-cols-4">
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <span className="h-9 w-9 rounded-xl bg-primary text-primary-foreground grid place-items-center font-head font-black">SA</span>
          <span className="font-head font-extrabold">San Antonio's Web Design</span>
        </div>
        <p className="text-sm text-muted-foreground max-w-xs">
          High-end, sales-focused websites, marketing, IT and repair services for San Antonio & surrounding areas.
        </p>
        <p className="text-sm flex items-center gap-2 text-muted-foreground"><MapPin className="h-4 w-4" /> San Antonio, TX</p>
      </div>

      <div>
        <h4 className="font-head font-bold mb-4">Company</h4>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link to="/services" className="hover:text-primary">Services</Link></li>
          <li><Link to="/portfolio" className="hover:text-primary">Portfolio</Link></li>
          <li><Link to="/templates" className="hover:text-primary">Templates</Link></li>
          <li><Link to="/pricing" className="hover:text-primary">Pricing</Link></li>
          <li><Link to="/blog" className="hover:text-primary">Blog</Link></li>
          <li><Link to="/reviews" className="hover:text-primary">Reviews</Link></li>
          <li><Link to="/areas" className="hover:text-primary">Areas We Serve</Link></li>
          <li><Link to="/partners" className="hover:text-primary">Partner Program</Link></li>
          <li><Link to="/terms" className="hover:text-primary" data-testid="footer-terms">Terms of Use</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-head font-bold mb-4">Tools & Shop</h4>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link to="/seo-tools" className="hover:text-primary">SEO Micro Tools</Link></li>
          <li><Link to="/shop" className="hover:text-primary">Tech Shop</Link></li>
          <li><Link to="/get-started" className="hover:text-primary">Order a Website</Link></li>
          <li><Link to="/account-login" className="hover:text-primary" data-testid="footer-account-login">My Account</Link></li>
          <li><Link to="/partner-login" className="hover:text-primary" data-testid="footer-partner-login">Partner Login</Link></li>
          <li><Link to="/careers" className="hover:text-primary" data-testid="footer-careers">Careers</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="font-head font-bold mb-4">Contact</h4>
        <ul className="space-y-3 text-sm text-muted-foreground">
          <li><Link data-testid="footer-contact" to="/contact" className="flex items-center gap-2 hover:text-primary"><Mail className="h-4 w-4" /> Contact Us</Link></li>
        </ul>
        <div className="flex items-center gap-3 mt-4" data-testid="footer-socials">
          <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="h-9 w-9 grid place-items-center rounded-full glass hover:text-primary"><Facebook className="h-4 w-4" /></a>
          <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="h-9 w-9 grid place-items-center rounded-full glass hover:text-primary"><Instagram className="h-4 w-4" /></a>
          <a href={CONTACT.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="h-9 w-9 grid place-items-center rounded-full glass hover:text-primary"><Youtube className="h-4 w-4" /></a>
          <a href={CONTACT.twitter} target="_blank" rel="noopener noreferrer" aria-label="X" className="h-9 w-9 grid place-items-center rounded-full glass hover:text-primary"><Twitter className="h-4 w-4" /></a>
          <a href={CONTACT.pinterest} target="_blank" rel="noopener noreferrer" aria-label="Pinterest" className="h-9 w-9 grid place-items-center rounded-full glass hover:text-primary font-bold text-sm">P</a>
        </div>
      </div>
    </div>
    <div className="border-t border-border py-5 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} San Antonio's Web Design. Built for speed, SEO & sales. · <Link to="/terms" className="hover:text-primary underline underline-offset-2">Terms of Use</Link>
    </div>
  </footer>
);
